import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// GET /api/inventory/orders — listOrders(). status omitted (falsy) means "all statuses".
//
// Moved from src/hooks/fetch-hooks/get-purchase-orders/fetch-purchase-orders.js onto the
// v2 hooks convention (throwIfRequestError) — see src/v2/hooks/request-error.js.
export default function usePurchaseOrders({ page, size, status }) {
    return useQuery(
        ["pharmacy-purchase-orders", page, size, status],
        async () => {
            const result = await request({
                url: "inventory/orders",
                method: "GET",
                params: status ? { page, size, status } : { page, size },
            });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;
            const { count, rows } = body.data;
            return { rows: rows || [], pagination: { page, size, total: Number(count) || 0 } };
        },
        { keepPreviousData: true, retry: false }
    );
}
